export function initVersionLog() {
  console.log('Build mode:', process.env.BUILD_MODE);
  console.log('Git Build Info:', process.env.BUILD_INFO);
  console.log('Git Commit ID:', process.env.COMMIT_ID);
}
